import qrcode from 'qrcode-generator'
const BIN_NAMES = ['irodori', 'kaori', 'ohana', 'koromogae']
const CLASS_NAME_TEIKIBIN_THEME = 'js-teikibin-theme'

document.addEventListener('DOMContentLoaded', () => {
  const elementsTeikibinTheme = document.getElementsByClassName(
    CLASS_NAME_TEIKIBIN_THEME
  )
  if (!elementsTeikibinTheme.length) return
  const bin =
    BIN_NAMES.find((name) => location.pathname.includes(name)) || BIN_NAMES[0]
  const url = `${location.origin}/pages/teikibin_${bin}`

  Array.from(elementsTeikibinTheme).forEach((element) => {
    const elementQr = element.querySelector('.js-teikibin-theme-qr')
    const qr = qrcode(4, 'L')
    qr.addData(url)
    qr.make()
    elementQr.innerHTML = qr.createSvgTag({
      margin: 0,
      scalable: true,
    })
  })
})
